import EFOcats_validate_checkbox from '../../../core/v2/validate/efocats_validate_checkbox.js';
import EFOcats_import_lang from '../../../core/v2/import/efocats_import_lang.js';
/**
 * checkboxチェッククラス
 */
export default class EFOcats_iwatani_validate_checkbox extends EFOcats_validate_checkbox {
  /**
   * エラーチェック
   */
  validate(checkData) {
    const result = super.validate(checkData);

    if (result.status === 'error') {
      if (checkData.attr('name') === 'chk01' || checkData.attr('name') === 'agree[]') {
        result.message = EFOcats_import_lang.getValue('規約未選択');
      }
    }

    return result;
  }
}
